const MagazineItemShimmer = () => {
  return (
    <div className="w-[156px] h-[268px] p-3 flex flex-col gap-y-1 justify-between border border-border-primary rounded-xl">
      <div className="w-[132px] h-[112px] bg-surface-secondary animate-pulse rounded-lg" />

      <div className="w-full h-8 bg-surface-secondary animate-pulse rounded-lg" />
      <div className="w-full h-8 bg-surface-secondary animate-pulse rounded-lg" />
      <div className="w-full h-8 bg-surface-secondary animate-pulse rounded-lg" />
    </div>
  );
};

export default MagazineItemShimmer;
